// extracted by mini-css-extract-plugin
module.exports = {"content":"tab-messages_content__3s9RJ"};